export default __webpack_public_path__ + "static/media/ride-cover.0f38e6f7.svg";